export async function originalSha256(source: Blob): Promise<string> {
  // Hash the selected source, never the compressed master or a delivery thumbnail.
  const digest = await crypto.subtle.digest("SHA-256", await source.arrayBuffer());
  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, "0")).join("");
}
